export default "__VITE_ASSET__ChmJeDyk__"